import app from 'flarum/forum/app';
import {extend} from 'flarum/common/extend';
import UserCard from 'flarum/forum/components/UserCard';
import IndexPage from 'flarum/forum/components/IndexPage';
import DiscussionHero from 'flarum/forum/components/DiscussionHero';
// app.initializers.add('datlechin/flarum-usercard-uid', () => {
//   extend(UserCard.prototype, 'infoItems', function (items) {
//     const mid = this.attrs.user.id();
//     items.add('mid', app.translator.trans('ann-mid.forum.mid_text', { mid }), 60);
//   });
// });
app.initializers.add('ann/flarum-mid', () => {
  extend(DiscussionHero.prototype, 'items', function (items) {
      const mid = this.attrs.discussion.id();
      items.add('mid', <div onclick={() =>copytoclip(mid)}>mid.{mid}</div>, 5);
  });

});
function copytoclip(mid){
  navigator.clipboard.writeText(mid)
  app.alerts.show({ type: "success" }, "复制mid成功")
}
